import { NULL_ADDRESS } from 'shared/constants/constants';
import { RoomStatusEnum } from 'shared/constants/shared-enums';
import { CloserRoom } from 'shared/types/app-types';
import { epochToLocalUTC } from 'shared/utils/time';

const MS_IN_MINUTE = 60 * 1000;
const GAME_START_BUFFER_MS = 4.5 * MS_IN_MINUTE;

const NON_ACTIVE_STATUSES = [
  RoomStatusEnum.ReadyForGame,
  RoomStatusEnum.ReadyForReveal,
  RoomStatusEnum.Closed,
];

/**
 * Returns time in milliseconds until "no one joined" status should be shown.
 * This is 4.5 minutes before the actual deadline.
 */
export const getTimeUntilNoOneJoinedStatus = (closerRoom: CloserRoom): number => {
  const gameStartDeadline = epochToLocalUTC(closerRoom.deadline);
  const triggerTime = new Date(gameStartDeadline.getTime() - GAME_START_BUFFER_MS);
  return triggerTime.getTime() - Date.now();
};

/**
 * Determines whether to trigger the "no one joined" status display.
 */
export const shouldTriggerShowNoOneJoin = ({
  activeRoomId,
  roomStatus,
  playerA,
  playerB,
  address,
  closerRoom,
}: {
  activeRoomId: string;
  roomStatus: RoomStatusEnum;
  playerA: { address?: string };
  playerB: { address?: string };
  address: string;
  closerRoom: CloserRoom;
}): boolean => {
  if (!activeRoomId || !closerRoom?.deadline) return false;

  const isRoomOpen = !NON_ACTIVE_STATUSES.includes(roomStatus);
  const isOwner = playerA?.address?.toLowerCase() === address?.toLowerCase();
  const isOpponentMissing =
    playerB?.address === NULL_ADDRESS ||
    (playerB?.address !== NULL_ADDRESS && roomStatus === RoomStatusEnum.Open);

  return isRoomOpen && isOwner && isOpponentMissing;
};
